"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.MobileLightMeetingsHelper = void 0;
const Environment_1 = require("../models/Environment");
const JoinInfo_1 = require("../models/JoinInfo");
class MobileLightMeetingsHelper {
    static isAvailable(environment, flags, joinInfo) {
        const params = joinInfo.conversationQueryParams || {};
        const hasOptOut = ["lightExperience", "webjoin", "launchInBrowser"].some(name => params[name] !== undefined && params[name] !== "true");
        return (flags.enableMobileLightMeetings &&
            flags.enableMobilePage &&
            environment.deviceType === Environment_1.DeviceTypes.Mobile &&
            // The shared detector also labels Android tablets without a Mobile token as mobile.
            (environment.os !== Environment_1.OperatingSystems.Android || /\bMobile\b/i.test(environment.userAgent)) &&
            (environment.os === Environment_1.OperatingSystems.iOS || environment.os === Environment_1.OperatingSystems.Android) &&
            !environment.isTflEnvironment &&
            !environment.isDgjEnvironment &&
            !environment.isRoomOSEnvironment &&
            !joinInfo.isTflLink &&
            !joinInfo.dgjPartnerId &&
            params.webjoin === undefined &&
            params.launchInBrowser === undefined &&
            joinInfo.lightMeetingsExperienceInfo.isSupportedLink &&
            !joinInfo.lightMeetingsExperienceInfo.forceRedirectForDGJ &&
            !joinInfo.lightMeetingsExperienceInfo.forceRedirectTo &&
            (joinInfo.type === JoinInfo_1.JoinType.Meetup || joinInfo.type === JoinInfo_1.JoinType.MeetupWithCode) &&
            !hasOptOut);
    }
    static hasExplicitIntent(joinInfo) {
        var _a;
        return ((_a = joinInfo.conversationQueryParams) === null || _a === void 0 ? void 0 : _a.limo) === "true";
    }
}
exports.MobileLightMeetingsHelper = MobileLightMeetingsHelper;
